<template>
	<!--------------------
		START - Team Members
		-------------------->
	<div class="element-wrapper">
		<div class="element-actions actions-only">
			<div @click="showCollapse = !showCollapse"
			     :class="showCollapse ? 'collapsed' : null">
				<span v-if="showCollapse">
					<i class="os-icon os-icon-minus-circle"></i>
				</span>
				<span v-if="!showCollapse">
						<i class="os-icon os-icon-plus-circle"></i>
				</span>
			</div>
		</div>

		<h6 class="element-header"  @click="showCollapse = !showCollapse"
		    :class="showCollapse ? 'collapsed' : null" >
			{{ t.navigation.trend_matches }}
		</h6>
		<div class="element-box-tp">
			<b-collapse visible v-model="showCollapse" id="trend_matches">
				<div class="alert" v-if="status > 200">
					<span v-if="status == 401">
						{{ t.error.access_denied_content }}
					</span>
					<span v-if="status == 404">
						{{ t.error.notfound_content_list }}
					</span>
				</div>
				<div class="users-list-w" v-if="status == 200">
					<div class="user-w with-status" v-for="match in matches">
						<div class="user-name">
							<h5 class="user-title">
								{{ match.homeTeam }} Vs {{ match.awayTeam }}
							</h5>
							<div class="user-role">
								{{ match.bets }}
							</div>
						</div>
					</div>
          <router-link :to="{name: 'match_trends' }" class="centered-load-more-link"><span>{{ t.show_all }}</span></router-link>
        </div>
			</b-collapse>
		</div>
	</div>
	<!--------------------
	END - Team Members
	-------------------->
</template>

<script>
    export default {
        name: 'matchTrends',
        data () {
            return {
                showCollapse: false,
                t: this.$root.t,
                session: this.$root.session,
                matches: null,
	            status: 0,
                isLoading: false,
            }
        },
        mounted () {
           // this.fetchActivity();
            this.showCollapse = true;
        },
        methods: {
            fetchActivity ()
            {
                this.isLoading = true;
                this.$http.get(api+'api/v1/analytics/trend/matches')
                    .then(response => {
                        this.matches = response.body.result.matches;
                        this.status = response.status;
                        this.isLoading = false;
                    }, response => {
                        this.isLoading = false;
                        this.status = response.status;
                    })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/bets/widget/trends.vue